import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { ConfigProvider } from "antd";
import reportWebVitals from "./reportWebVitals";
import {
  PublicClientApplication,
  EventType,
  AuthenticationResult,
  LogLevel,
} from "@azure/msal-browser";

const pca = new PublicClientApplication({
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID || '',
    authority: process.env.REACT_APP_AUTHORITY,
    redirectUri: process.env.REACT_APP_REDIRECT_URI,
    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true
  },
  system: {
    allowRedirectInIframe: true,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
        }
      },
      logLevel: LogLevel.Error
    }
  }
});

pca.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    pca.setActiveAccount(account);
  }
});

export const loginRequest = {
  scopes: ["User.Read", "User.Read.All"],
};

// One font for the whole app. Ant Design components read it from the theme token; static
// pop-ups (Modal.confirm, message, notification) render outside the React tree, so
// holderRender gives them the same theme.
const APP_FONT_FAMILY =
  "'Inter', 'Segoe UI', system-ui, -apple-system, Roboto, 'Helvetica Neue', sans-serif";
const appTheme = { token: { fontFamily: APP_FONT_FAMILY } };
ConfigProvider.config({
  holderRender: (children) => <ConfigProvider theme={appTheme}>{children}</ConfigProvider>,
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <ConfigProvider theme={appTheme}>
      <App msalInstance={pca} />
    </ConfigProvider>
  </React.StrictMode>
);
reportWebVitals();